<template>
  <!-- @mouseover="mouseover" @mouseout="mouseout" -->
  <div class="homeHeaderCon">
    <div class="homeHeaderP" :style="{ 'background-color': homeheaderbgcolor }">
      <div class="homeHeader">
        <div class="logo" @click="gofirstPage">
          <img v-if="logosrc" :src="logosrc" alt="logo" />
        </div>
        <div class="otherCon" :style="{ 'justify-content': navpos }">
          <div class="nav">
            <ul class="nav-content">
              <li
                v-for="(item, index) in modelsInfo"
                v-if="item.status == 1"
                :key="index"
                @click="changeModel(item, index)"
              >
                <router-link
                  :class="{
                    activeSty: index == activeChanelIndex,
                    noactiveSty: index != activeChanelIndex,
                    disable: item.page_name == '视频素材222221212'
                  }"
                  to
                  v-text="item.page_name"
                ></router-link>
              </li>
              <!-- <li v-if="payment == 10" class="first-menu"><router-link to="/PackagePrice" >套餐价格</router-link></li> -->
            </ul>
          </div>
        </div>
        <div style=" align-items: center;display: flex;">
          <div class="loginBtn" v-if="!userInfo">
            <div class="btnContent">
              <div
                style="margin-right:5px"
                class="iconfont icon-Shapecopy"
              ></div>
              <div class="loginbtn-item">
                <router-link class="login-left" to="/login">登录</router-link>
              </div>
              <div>/</div>
              <div class="loginbtn-item">
                <router-link class="login-right" to="/register"
                  >注册</router-link
                >
              </div>
            </div>
          </div>
          <div class="userPerson userInfo" v-else>
            <el-dropdown trigger="click" placement="top" v-if="userInfo">
              <div class="personLogo">
                <span>
                  {{ userInfo.user_name }}
                  <i class="el-icon-arrow-down"></i>
                </span>
                <a class="userHead">
                  <img :src="userInfo.img_path" alt />
                </a>
              </div>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item>
                  <span @click="toPersonal">个人中心</span>
                </el-dropdown-item>
                <el-dropdown-item>
                  <span @click="signOut">退出登录</span>
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import { getModuleInfo, signOut } from "./../services/api.js";
import pbmethod from "../publicmethod.js";

export default {
  data() {
    return {
      navpos: "center",
      select: "0",
      searchText: "",
      homeColor: {
        id: "",
        list: [{ body: "rgba(255,255,255)" }]
      },
      logo: {
        id: "",
        list: [{ photo1: "" }]
      },
      realopacity: this.opacity,
      homeheaderbgcolor: "rgba(255,255,255)",
      keyI: 0,
      payment: ""
    };
  },
  props: {
    opacity: {
      type: String,
      default() {
        return "0.5";
      }
    },
    issearch: {
      type: Boolean,
      default() {
        return true;
      }
    }
  },
  created() {
    if (this.$route.query.text) {
      this.select = this.$route.query.type;
      this.searchText = decodeURI(this.$route.query.text);
    }
  },
  watch: {
    keyI(val) {
      if (val == 13) {
        this.toSearch();
      }
    },
    opacity: {
      handler() {
        this.realopacity = this.opacity;
        if (this.opacity == "1") {
          this.homeheaderbgcolor = pbmethod.colorRgb(
            this.homeColor.list[0].body
          );
        } else {
          this.homeheaderbgcolor = pbmethod.colorRgb(
            this.homeColor.list[0].body,
            "0.5"
          );
        }
      },
      immediate: true
    },
    realopacity() {
      if (this.realopacity == "1") {
        this.homeheaderbgcolor = pbmethod.colorRgb(this.homeColor.list[0].body);
      } else {
        this.homeheaderbgcolor = pbmethod.colorRgb(
          this.homeColor.list[0].body,
          "0.5"
        );
      }
    }
  },
  mounted() {
    this.payment = window.localStorage.getItem("payment"); // 1 支付开, 0 关闭支付
    this.keyevent();
    this.getModuleInfo();
  },
  computed: {
    logosrc() {
      if (this.logo.list.length > 0) {
        this.setLogoSrc(this.logo.list[0].photo1);
        return this.logo.list[0].photo1;
      } else {
        this.setLogoSrc("");
        return "";
      }
    },
    userInfo() {
      return sessionStorage.getItem("user")
        ? JSON.parse(sessionStorage.getItem("user"))
        : false;
    },
    Logo() {
      return this.logo;
    },
    ...mapGetters([
      "modelsInfo",
      "webModels",
      "curModelInfo",
      "webID",
      "activeChanelIndex"
    ])
  },
  methods: {
    getNavPos() {},
    keyevent() {
      var that = this;
      document.onkeydown = function(e) {
        //按下键盘
        that.keyI = e.keyCode;
      };
    },
    gofirstPage() {
      this.$router.push({ path: "/" });
    },
    mouseover() {
      // this.realopacity = 1;
    },
    mouseout() {
      // this.realopacity = 0.68;
    },
    ...mapActions(["setCurModelInfo", "setActiveChanelIndex", "setLogoSrc"]),
    signOut() {
      signOut().then(res => {
        localStorage.removeItem("user");
        localStorage.removeItem("token");
        sessionStorage.removeItem("user");
        sessionStorage.removeItem("token");

        window.location.href = "https://login.ihep.ac.cn/logout";
      });
    },
    changeModel(module, index) {
      // this.setCurModelInfo(module);
      if (module.page_name == "视频素材4442323323") {
        this.$message({
          type: "warning",
          showClose: true,
          message: "建设中",
          duration: 1000
        });
        return;
      }
      this.setActiveChanelIndex(index);
      if (module.tpl_id === 4) {
        this.$router.push({ path: "/special" });
      } else {
        this.$router.push({ path: "/" });
      }
    },
    toSearch() {
      this.$router.push({
        path: "/search",
        query: {
          type: this.select,
          text: encodeURI(this.searchText)
        }
      });
    },
    toPersonal() {
      var token = sessionStorage.getItem("token");
      window.open(
        "http://saasdam.vcg.com/#/login?token=" + token + "&activename=name1",
        "_blank"
      ).location;
    },
    getModuleInfo() {
      var id = setInterval(() => {
        if (this.$store.getters.webModels.module_data) {
          clearInterval(id);
          var logo = this.webModels.module_data.find(item => {
            if (item.title == "logo") return item;
          });
          var homeColor = this.webModels.module_data.find(item => {
            if (item.title == "首页底色") return item;
          });
          let data = {
            module_id: logo.id,
            web_id: this.webID,
            use_sort_num: 1,
            sort: "asc"
          };

          getModuleInfo(data, {
            page: 1,
            page_nums: logo.rows_num
          }).then(res => {
            if (res.status_code == 1) {
              this.logo = {
                id: logo.id,
                list: res.data.list
              };
            }
          });
          data.module_id = homeColor.id;
          //
          getModuleInfo(
            { module_id: 5, use_sort_num: 1, sort: "asc" },
            null
          ).then(res => {
            if (res.status_code == 1) {
              this.homeColor = {
                id: homeColor.id,
                list: res.data.list
              };
              this.homeheaderbgcolor = pbmethod.colorRgb(
                this.homeColor.list[0].body
              );
            }
          });

          data = {
            module_id: 23,
            web_id: this.webID,
            use_sort_num: 1,
            sort: "asc"
          };
          getModuleInfo(data).then(res => {
            if (res.status_code == 1) {
              switch (res.data.list[0].nav) {
                case 1:
                  this.navpos = "flex-start";
                  break;
                case 2:
                  this.navpos = "center";
                  break;
                case 3:
                  this.navpos = "flex-end";
                  break;
              }
            }
          });
        }
      }, 0);
    }
  }
};
</script>
<style lang="less">
.el-dropdown-menu__item {
  padding: 0;
  span {
    display: block;
    padding: 0 15px;
  }
}
</style>

<style lang="less" scoped>
.activeSty {
  color: black;
  font-weight: bold;
}
.noactiveSty {
  color: #333;
}
.disable {
  color: rgba(0, 0, 0, 0.3);
}
.nav-content {
  li {
    margin-left: 40px;
  }
}
.homeHeaderCon {
  width: 100%;
  height: 70px;
  padding-left: 0px;
  padding-right: 0px;
  margin-right: auto;
  margin-left: auto;
}
.homeHeaderP {
  width: 100%;
  height: 70px;
  .homeHeader {
    margin: 0 auto;
    max-width: 1200px;
    height: 70px;
    display: flex;
    display: -webkit-flex;
    justify-content: space-between;
    z-index: 1000;
    .logo {
      height: 100%;
      width: 120px;
      display: flex;
      align-items: center;
      justify-content: center;
      img {
        max-width: 120px;
        max-height: 60px;
      }
    }
    .otherCon {
      display: flex;
      display: -webkit-flex;
      align-items: center;
      width: calc(100% - 120px);
    }
    .nav {
      margin-right: 20px;
      min-width: 200px;
      .nav-content {
        display: flex;
        height: 20px;
        font-size: 14px;
        font-family: PingFang-SC-Medium;
        line-height: 20px;
        // padding-top: 24px;
        justify-content: flex-start;
        li {
          color: rgba(44, 62, 76, 1);
          a {
            font-size: 14px;
          }
        }
      }
    }
    .search {
      width: 345px;
      height: 40px;
      margin-right: 40px;
      display: flex;
      .el-select {
        padding-right: 0;
        width: 150px;
      }
      .el-button {
        background-color: #f05941;
        color: #fff;
        padding: 0px;
        height: 40px;
        width: 40px;
        font-size: 20px;
      }
      .el-input-group {
        width: 250px;
      }
    }
    .loginBtn {
      width: 98px;
      height: 40px;

      border-radius: 3px;
      .btnContent {
        line-height: 20px;
        height: 20px;
        width: 85px;
        margin-top: 10px;
        margin-left: 8px;
        display: flex;
        justify-content: space-between;

        a {
          color: #333;
          font-size: 14px;
        }
        a:hover {
          color: red;
        }
      }
    }
    .userInfo {
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: flex-end;
      .personLogo {
        display: flex;
        display: -webkit-flex;
      }
      span {
        font-size: 16px;
        // line-height: 45px;
        cursor: pointer;
        vertical-align: middle;
        display: flex;
        display: -webkit-flex;
        align-items: center;
      }
      .userHead {
        margin-left: 10px;
        display: inline-block;
        width: 45px;
        height: 45px;
        vertical-align: middle;
        cursor: pointer;
        img {
          width: 100%;
          height: 100%;
          border-radius: 50%;
        }
      }
    }

    .homeHeaderTwo {
      width: 100%;
      height: 70px;
      position: fixed;
      display: flex;
      z-index: 1000;
      .logo {
        height: 100%;
        width: 120px;
        color: #fff;
        display: flex;
        justify-content: center;
        align-items: center;
        img {
          max-width: 100%;
          max-height: 100%;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/homeHeader.vue